module.exports = __webpack_public_path__ + "static/media/img177.7a2304a5.jpg";